import React from 'react'
import './style.scss'

export default function SearchBar({ searchString, onChange, isConsolidate = false }) {
  return (
    <div className="search-wrap">
      <svg
        className="search-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input
        className="input"
        type="text"
        placeholder={
          isConsolidate
            ? 'Search Name / Mobile Number'
            : 'Search Name / Mobile Number / Order Reference'
        }
        value={searchString}
        onChange={onChange}
      />
    </div>
  )
}
